// extracted by mini-css-extract-plugin
export default {"linkPrimary":"Link_linkPrimary__xLbH5","active":"Link_active__Eqd5W"};